import '../styles/design-tokens.css';
import PageLayout from '../components/home/PageLayout';

/* ── 3 service items — icons match the original HTML exactly ── */
const SERVICES = [
  {
    icon:  'fa-file-text-o',
    title: 'Corporate and in-class Linguistic Training in German, Swedish, French, Italian, Spanish, Czech and English',
  },
  {
    icon:  'fa-university',
    title: 'Learn and Earn Consultancy Abroad',
  },
  {
    icon:  'fa-globe',
    title: 'Help You Prepare for Jobs Abroad',
  },
];

/* ── 3 alternating rows — layout + body text matches original HTML ── */
const CONTENT_ROWS = [
  {
    img:     '/images/Corporate_training.jpg',
    imgAlt:  'Corporate Trainings',
    imgLeft: false,
    heading: 'Corporate Trainings',
    body:    'Understanding professional requirements and practicing formal ways of language learning, we are honoured to be the most trusted organization in corporate linguistic training. All four aspects of learning i.e. reading, writing, listening, speaking along with technical vocabulary and door step services for companies enrich the experience for our corporate clients.',
  },
  {
    img:     '/images/wqe.jpg',
    imgAlt:  'Online Languages Classes',
    imgLeft: true,
    heading: 'Online Languages Classes',
    body:    'Understanding the need of the hour, online languages classes for professionals, students who deal with their busy and scheduled life and can learn the languages with utmost accuracy, flexibility of time and lots of exercises.',
  },
  {
    img:     '/images/students-e1593855687415.jpeg',
    imgAlt:  'Our Expertise In Figures',
    imgLeft: false,
    heading: 'Our Expertise In Figures',
    body:    'Here We have successfully trained about 1000 students and sent to renowned Universities in UK, Europe and USA.',
  },
];

export default function LingualServicesPage() {
  return (
    <PageLayout
      title="SOMAYYA'S GLOBAL LINGUISTIC TRAINING"
      breadcrumb="Lingual Services"
    >
      {/* ── Intro Section ── */}
      <div className="sa-ls-section sa-inner-section-white">
        <div className="sa-container">
          <div className="sa-ls-section-header">
            <h1 className="sa-heading-page-title">Global Linguistic Training</h1>
            <hr className="sa-sa-full-divider" />
          </div>
          <p className="sa-ls-intro-para">
            Established in 2013, our Institute has been associated with a wide array of
            Large and Medium sized Corporates. We have built a steadily rising reputation
            for ourselves having groomed executives to be linguists in French, German,
            Swedish &amp; English enabling them to move up in the corporate world globally
            with head held high.
          </p>
        </div>
      </div>

      {/* ── Services Includes ── */}
      <div className="sa-ls-section sa-inner-section-white">
        <div className="sa-container">
          <div className="sa-ls-services-header">
            <h2 className="sa-sa-intro-heading">The Services Includes</h2>
            <hr className="sa-sa-full-divider" />
          </div>
          <div className="sa-sa-services-icon-grid">
            {SERVICES.map(s => (
              <div key={s.title} className="sa-sa-service-icon-card">
                <div className="sa-sa-service-icon-circle">
                  <i className={`fa ${s.icon}`} aria-hidden="true" />
                </div>
                <h3 className="sa-sa-service-icon-title">{s.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Alternating Image / Text Content Rows ── */}
      <div className="sa-ls-section sa-inner-section-white">
        <div className="sa-container">
          {CONTENT_ROWS.map(row => (
            <div key={row.heading} className="sa-sa-content-row">
              {row.imgLeft ? (
                <>
                  <div className="sa-sa-content-row-img">
                    <img src={row.img} alt={row.imgAlt} />
                  </div>
                  <div className="sa-sa-content-row-text">
                    <h3>{row.heading}</h3>
                    <p>{row.body}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="sa-sa-content-row-text">
                    <h3>{row.heading}</h3>
                    <p>{row.body}</p>
                  </div>
                  <div className="sa-sa-content-row-img">
                    <img src={row.img} alt={row.imgAlt} />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
